export enum SignalRNotificationTypes {
    INFO = 0,
    SUCCESS = 1,
    WARNING = 2,
    ERROR = 3,
}

export enum SignalRTypes {
    RESPONSE = 0,
    MESSAGECENTER = 1,
    STATIC = 2,
}
